/* eslint-disable no-magic-numbers */
import { useAppSelector } from '@/redux/hooks/useAppSelector';
import { LoadingIndicator } from '@/shared/LoadingIndicator';
import React from 'react';
import { modelElementsByModelIdSelector } from '@/redux/modelElements/modelElements.selector';
import { ModelElement, NewReaction } from '@/types/models';
import { ZERO } from '@/constants/common';
import { BioEntitiesPinsListItem } from '../../SearchDrawerWrapper/BioEntitiesResultsList/BioEntitiesPinsList/BioEntitiesPinsListItem';

export const ConnectedBioEntitiesList = ({
  reaction,
}: {
  reaction?: NewReaction;
}): React.ReactNode => {
  const isPending = reaction === undefined || reaction === null;
  const modelElements2: ModelElement[] = useAppSelector(state =>
    modelElementsByModelIdSelector(state, reaction?.map || ZERO),
  );

  if (isPending) {
    return <LoadingIndicator />;
  }

  const modelElements: ModelElement[] = [];
  reaction.reactants.forEach(reactant => {
    modelElements.push(
      ...modelElements2.filter(modelElement => modelElement.id === reactant.element),
    );
  });
  reaction.products.forEach(reactant => {
    modelElements.push(
      ...modelElements2.filter(modelElement => modelElement.id === reactant.element),
    );
  });
  reaction.modifiers.forEach(reactant => {
    modelElements.push(
      ...modelElements2.filter(modelElement => modelElement.id === reactant.element),
    );
  });

  return (
    <div>
      <h3 className="mb-1 font-semibold">Reaction elements:</h3>
      {modelElements.map(modelElement => (
        <BioEntitiesPinsListItem
          name={modelElement.name}
          pin={{ ...modelElement, annotations: modelElement.references }}
          key={modelElement.id}
          entityNumberKey={modelElement.id}
        />
      ))}
    </div>
  );
};
